import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SolEstimateFormGroup } from '../../models/sol-estimate-table/SolEstimateFormGroup';
import { SolEstimateTableRowBase } from '../../models/sol-estimate-table/SolEstimateTableRowBase';
import { SolEstimateTableSellAsBase } from '../../models/sol-estimate-table/SolEstimateTableSellAsBase';
import { MultilingualCurrencyPipe } from '../../pipes/multilingual-currency-pipe/multilingual-currency.pipe';
import { DecimalPrecisionPipe } from '../../pipes/decimal-precision-pipe/decimal-precision.pipe';

@Component({
  selector: 'app-sol-estimate-totals',
  imports: [
    TranslatePipe,
    CommonModule,
    MultilingualCurrencyPipe,
    DecimalPrecisionPipe
  ],
  templateUrl: './sol-estimate-totals.component.html',
  styleUrl: './sol-estimate-totals.component.scss'
})
export class SolEstimateTotalsComponent {

  @Input() isMarkUpSelected: boolean = false;
  @Input() estimateFormGroup: FormGroup<SolEstimateFormGroup>;
  @Input() escalationTotal: number = 0;

  constructor() { }

  get subTotals(): FormGroup<SolEstimateTableRowBase> | null {
    return this.estimateFormGroup?.controls.subTotals ?? null;
  }

  get sellAsCalculated(): FormGroup<SolEstimateTableSellAsBase> | null {
    return this.estimateFormGroup?.controls.sellAs.controls.calculated ?? null;
  }


}
